import React, { useEffect, useState } from "react";
import FormHeader from "../../../components/dms_common/FormHeader";
import CustomAccordian from "../../../components/dms_common/CustomAccordian";
import BorderHeading from "../../../components/heading/BorderHeading";
import {
  approvalStatusMapping,
  stockAdjustSkuDetailsGridMetaData,
  stockAdjustSkuDetailsMetaData1,
  stockAdjustSkuDetailsMetaData2,
} from "./ManualStockAdjustmentUtils";
import CustomDataGrid from "../../../components/dms_common/CustomDataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import StockAdjustRejectionModal from "../modal/StockAdjustRejectionModal";
import { ManualStockAdjustmentRowsData, ManualStockSkuDetail } from "../../../types/types";
import { setOpen, setSelectedRowToEdit } from "../../../stateManagement/actions/claims";
import { useDispatch } from "react-redux";

interface skuDetailsRowsData {
  id: string;
  batchId: string;
  currentPieceStockQty: number;
  updatedPieceStockQty: number;
  currentCaseStockQty: number;
  updatedCaseStockQty: number;
  currentOtherStockQty: number;
  updatedOtherStockQty: number;
  reasonForAdjustment: string;
  status: string;
  parentStatus: string;
  otherUnitName?: string
}

const StockAdjustSkuDetailsScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const productData = location.state as ManualStockAdjustmentRowsData;
  const [rows, setRows] = useState<skuDetailsRowsData[]>([]);
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);


  console.log(productData,"productData")
  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsExpanded(!isExpanded);
  };

  const openRejectionModal = () => {
    dispatch(setSelectedRowToEdit(productData));
    dispatch(setOpen(true));
  };

  useEffect(() => {
    const tempSkuDetails: skuDetailsRowsData[] = [];
    productData.skuDetails.forEach((item: ManualStockSkuDetail) => {
      tempSkuDetails.push({
        id: item.batchId,
        batchId: item.batchId,
        currentPieceStockQty: item.currentPieceBatchQty,
        updatedPieceStockQty: item.updatedPieceBatchQty,
        currentCaseStockQty: item.currentCaseBatchQty,
        updatedCaseStockQty: item.updatedCaseBatchQty,
        currentOtherStockQty: item.currentOtherBatchQty,
        updatedOtherStockQty: item.updatedOtherBatchQty,
        reasonForAdjustment: item.reasonForAdjustment,
        status: item.individualStatus,
        parentStatus: productData.status,
        otherUnitName: productData.otherUnitName
      });
    });
    setRows(tempSkuDetails);
  }, []);

  return (
    <div className="view_order_parent_vo" style={{ height: "100%" }}>
      <div className="view_order_header_with_search">
        <div className="view_order_header">
          <FormHeader
            parentLabel={"Manual Stock Adjustment"}
            label={"SKU Details"}
            goBackToParent={() => navigate(-1)}
          />
        </div>
      </div>
      <CustomAccordian
        expanded={!isExpanded}
        onCustomAccordionToggle={onCustomAccordionToggle}
        isSecondHalf={true}
        metaData1={stockAdjustSkuDetailsMetaData1}
        data1={productData}
        metaData2={stockAdjustSkuDetailsMetaData2}
        data2={productData}
        header={`SKU Code ${productData.skuCode}`}
        label1={""}
        label2=""
        dateAndTimeLabel=""
        status= {""}
        linkText={
          productData?.status?.toLowerCase() === "rejected" ? "See Reason For Rejection" : ""
        }
        linkTextOnClick={openRejectionModal}
        singleColumnInEachHalf={true}
      />
      <div>
        <div className="view_order_button_container">
          <BorderHeading>View Details</BorderHeading>
        </div>
      </div>
      <CustomDataGrid
        rows={rows}
        columnsMetaData={stockAdjustSkuDetailsGridMetaData}
        orderStatusConfig={approvalStatusMapping}
        tableWidth={0.765}
        enableRowClickRedirect={false}
      />
      <StockAdjustRejectionModal
        heading={`${productData.skuDescription} (${productData.skuCode})`}
      />
    </div>
  );
};

export default StockAdjustSkuDetailsScreen;
